import { render, staticRenderFns } from "./SummaryLeadsSourcesCard.vue?vue&type=template&id=88c2f954&scoped=true"
import script from "./SummaryLeadsSourcesCard.vue?vue&type=script&lang=js"
export * from "./SummaryLeadsSourcesCard.vue?vue&type=script&lang=js"
import style0 from "./SummaryLeadsSourcesCard.vue?vue&type=style&index=0&id=88c2f954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c2f954",
  null
  
)

export default component.exports